import { SidebarMenu } from '../../../enum/SidebarMenu';
import icon from '../../../assets/img/svg/sidebar/cash-register.svg';

export const cashRegister = {
  sidebarMenuType: SidebarMenu.CASH_REGISTER,
  label: 'sidebar.cashRegister.title',
  path: '/cash-register',
  routes: undefined,
  icon: icon,
  headerConfig: {
    search: true,
    datePicker: true,
    sumBy: false,
    columnOrder: false,
    updateData: true,
  },
  footerConfig: { visibleItemsCount: true },
  testId: 'cashregister',
};
